import { useLocation, useNavigate } from 'react-router-dom'

function toLocation(to, state) {
    if (typeof to === 'string') {
        return {
            to,
            options: state === undefined ? {} : { state },
        }
    }

    const location = {}
    if (to.pathname !== undefined) location.pathname = to.pathname
    if (to.search !== undefined) location.search = to.search
    if (to.hash !== undefined) location.hash = to.hash

    const options = {}
    const nextState = to.state !== undefined ? to.state : state
    if (nextState !== undefined) options.state = nextState
    return { to: location, options }
}

export function useHistory() {
    const navigate = useNavigate()
    const location = useLocation()

    return {
        push(to, state) {
            const target = toLocation(to, state)
            navigate(target.to, target.options)
        },
        replace(to, state) {
            const target = toLocation(to, state)
            navigate(target.to, { ...target.options, replace: true })
        },
        goBack() {
            navigate(-1)
        },
        location,
    }
}
